import React from 'react';

const PageTitle404 = () => {
    return (
        <div id="page-title">
            <div className="wrapper">
                <div className="title">
                    <h1 className="large">404 Error</h1>
                </div>
            </div>
        </div>
    );
};

export default PageTitle404;
